"use client";

import { useState, useEffect, useRef } from "react";
import { useParams } from "@/hooks";
import { AppDispatch } from "@/store";
import { useDispatch, useSelector } from "react-redux";
import {
  createSellEmployeeProducts,
  fetchProducts,
} from "@/store/modules/products/thunks";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { employeeSaleSchema } from "@/validations";
import { usePermission } from "../usePermission/usePermission";
import { useAuth } from "@/context/AuthContext";
import { UseSellEmployeeProductsProps } from "@/types";
import { fetchFullCommission } from "@/store/modules/fullCommission/thunks";

const useSellEmployeeProducts = ({
  dateRange,
  onSuccess,
}: UseSellEmployeeProductsProps) => {
  const { hasPermission, loading: loadingPermission } = usePermission();
  const { currency, establishment } = useAuth();
  const { params, setParams, handlePage } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    watch,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(employeeSaleSchema),
    defaultValues: {
      user_id: undefined,
      product: {
        product_id: undefined,
        quantity: 1,
      },
      due_date: "",
      total_price: "",
    },
  });

  const setFormData = (
    data: Partial<typeof employeeSaleSchema.__outputType>,
  ) => {
    reset(data);
  };

  const onSubmit = async (data: typeof employeeSaleSchema.__outputType) => {
    try {
      let result;

      result = await dispatch(createSellEmployeeProducts(data));

      if (createSellEmployeeProducts.fulfilled.match(result)) {
        if (onSuccess) onSuccess();
        dispatch(
          fetchFullCommission({
            ...params,
            start_date: dateRange.start.toISOString().split("T")[0],
            end_date: dateRange.end.toISOString().split("T")[0],
          } as any),
        );
        reset();
      }
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
    }
  };

  const { sellEmployee, products, loading, error } = useSelector(
    (state: any) => state.products,
  );
  const dispatch: AppDispatch = useDispatch();

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (hasPermission("read product") && !hasFetchedRef.current) {
      const payload = {
        ...params,
      };
      dispatch(fetchProducts(payload));
      hasFetchedRef.current = true;
    }
  }, []);

  return {
    register,
    handleSubmit,
    onSubmit,
    reset,
    errors,
    isSubmitting,
    products,
    loading,
    error,
    setFormData,
    getValues,
    control,
    handlePage,
    params,
    currency,
    sellEmployee,
    watch,
    setValue,
  };
};

export default useSellEmployeeProducts;
